import React from 'react'

const iconStyle: React.CSSProperties = {
  stroke: '#3E3E47',
  strokeWidth: '2',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

const InfoIconWMO = ({
  width = '24px',
  height = '24px',
  viewBox = '0 0 24 24',
  customProps = {},
}) => (
  <svg width={width} height={height} viewBox={viewBox} {...customProps} fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      style={iconStyle}
    />
    <path
      d="M12 16V12"
      style={iconStyle}
    />
    <path
      d="M12 8H12.01"
      style={iconStyle}
    />
  </svg>
)

export default InfoIconWMO
